import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/secretsProvider.ee.ts
const getSecretProviderTypes = async (context) => {
	return await makeRestApiRequest(context, "GET", "/secret-providers/types");
};
const getSecretProviderConnections = async (context) => {
	return await makeRestApiRequest(context, "GET", "/secret-providers/connections");
};
const getSecretProviderConnectionByKey = async (context, providerKey) => {
	return await makeRestApiRequest(context, "GET", `/secret-providers/connections/${providerKey}`);
};
const createSecretProviderConnection = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/secret-providers/connections", data);
};
const updateSecretProviderConnection = async (context, providerKey, data) => {
	return await makeRestApiRequest(context, "PATCH", `/secret-providers/connections/${providerKey}`, data);
};
const testSecretProviderConnection = async (context, providerKey) => {
	return await makeRestApiRequest(context, "POST", `/secret-providers/connections/${providerKey}/test`);
};
const deleteSecretProviderConnection = async (context, providerKey) => {
	return await makeRestApiRequest(context, "DELETE", `/secret-providers/connections/${providerKey}`);
};
const getProjectSecretProviderConnectionsByProjectId = async (context, projectId) => {
	return await makeRestApiRequest(context, "GET", `/secret-providers/projects/${projectId}/connections`);
};

//#endregion
export { getSecretProviderConnections as a, updateSecretProviderConnection as c, getSecretProviderConnectionByKey as i, deleteSecretProviderConnection as n, getSecretProviderTypes as o, getProjectSecretProviderConnectionsByProjectId as r, testSecretProviderConnection as s, createSecretProviderConnection as t };
//# sourceMappingURL=secretsProvider.ee.mjs.map